export default __webpack_public_path__ + "static/Signika-SemiBold-18caa36fc1ae3db9dcda84df198dea31.ttf";